import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { OptionApi } from 'api';
import { OPTION_TYPE } from 'utils';

export const findOptionForTableList = createAsyncThunk(
  'option/findOptionForTableList',
  async (option: Record<string, any>, { rejectWithValue }) => {
    try {
      const response = await OptionApi.find(option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findOption = createAsyncThunk(
  'option/findOption',
  async (option: Record<string, any>, { rejectWithValue }) => {
    try {
      const response = await OptionApi.find(option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findOptionsWithAuth = createAsyncThunk(
  'option/findOptionsWithAuth',
  async (credential, { rejectWithValue }) => {
    try {
      const response = await OptionApi.findWithAuth();

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findOptionForFilterList = createAsyncThunk(
  'option/findOptionForFilterList',
  async (option: Record<string, any>, { rejectWithValue }) => {
    try {
      const response = await OptionApi.find(option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const createOption = createAsyncThunk(
  'option/createOption',
  async (body: Record<string, any>, { rejectWithValue }) => {
    try {
      const response = await OptionApi.create(body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findOneOption = createAsyncThunk(
  'option/findOneOption',
  async (params: any, { rejectWithValue }) => {
    try {
      const { id, option } = params;
      const response = await OptionApi.findOne(id, option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const updateOption = createAsyncThunk(
  'option/updateOption',
  async (params: any, { rejectWithValue }) => {
    try {
      const { id, body } = params;
      const response = await OptionApi.update(id, body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const deleteOption = createAsyncThunk(
  'option/deleteOption',
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await OptionApi.delete(id);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findProductOption = createAsyncThunk(
  'option/findProductOption',
  async (entityID: string, { rejectWithValue }) => {
    try {
      const response = await OptionApi.findOptionWithType({
        entityID,
        type: OPTION_TYPE.PRODUCT,
      });

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const updateOptionStatus = createAsyncThunk(
  'option/updateOptionStatus',
  async (params: any, { rejectWithValue }) => {
    try {
      const { id, body } = params;
      const response = await OptionApi.updateStatus(id, body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

interface IState {
  tableList: Array<any>;
  list: Array<any>;
  reloadFlag: boolean;
  isLoadedProductOption: boolean;
  productOptionList: Array<any>;
}

const initialState: IState = {
  tableList: [],
  list: [],
  reloadFlag: false,
  productOptionList: [],
  isLoadedProductOption: false,
};

const optionSlice = createSlice({
  name: 'option',
  initialState,
  reducers: {
    reloadOption(state) {
      state.reloadFlag = !state.reloadFlag;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(findOptionForTableList.fulfilled, (state, action) => {
        const { data } = action.payload;
        const newData = data.map(item => {
          return {
            ...item,
            key: item.id,
            value: item.id,
            phoneNumber: item.user.phoneNumber,
            type: item.type,
          };
        });

        state.tableList = newData;
      })
      .addCase(findOptionForFilterList.fulfilled, (state, action) => {
        const { data } = action.payload;

        const newData = data.map(item => {
          return {
            ...item,
            key: item.id,
            value: item.id,
          };
        });

        state.list = newData;
      })
      .addCase(deleteOption.fulfilled, (state, action) => {
        const { data } = action.payload;
        const newData = [data].filter(item => item.id !== data.id);

        state.list = newData;
        state.isLoadedProductOption = false;
      })
      .addCase(createOption.fulfilled, (state, action) => {
        const { data } = action.payload;

        const newData = [data].concat(state.list);

        state.list = newData;
        state.isLoadedProductOption = false;
      })
      .addCase(updateOption.fulfilled, (state, action) => {
        const { data } = action.payload;

        const index = state.list.findIndex(item => item.id === data.id);
        const newData = state.list.splice(index, 1, data);

        state.list = newData;
        state.isLoadedProductOption = false;
      })
      .addCase(findProductOption.fulfilled, (state, action) => {
        const { data } = action.payload;

        const newData = (data || []).map((item: any) => {
          return {
            ...item,
            key: item.id,
            value: item.id,
            name: item.content,
          };
        });

        state.productOptionList = [
          {
            key: 'all',
            value: 'all',
            name: 'Tất cả nhãn',
          },
          ...newData,
        ];

        state.isLoadedProductOption = true;
      });
  },
});

const { actions, reducer: optionReducer } = optionSlice;

export const { reloadOption } = actions;

export default optionReducer;
